// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","cardFormCity":"_1Kz5bxeK0ctAlfzyXsh4-G","cardFormSummary":"_3tUU6v79CJbuJBCEAUKBAb"};